var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement, eventOptions } from 'lit/decorators.js';
import { env } from '../environment';
import style from '../css/dropdown.css';
let Dropdown = class Dropdown extends LitElement {
    constructor() {
        super(...arguments);
        this.type = '';
        this.id = '';
        this.title = '';
        this.visibility = false;
        this.visible = '';
        this.arrow = 'down';
        this._handleOutsideClick = (e) => {
            const clickedElem = e.composedPath()[0].getRootNode();
            const containerClickedElem = e.composedPath()[2].getRootNode();
            if (clickedElem.getRootNode() != this.shadowRoot && containerClickedElem.getRootNode() != this.shadowRoot) {
                this.visible = '';
                this.arrow = 'down';
                this.visibility = false;
            }
        };
    }
    static get styles() {
        if (env.debug) {
            return css `
        `;
        }
        return [style];
    }
    connectedCallback() {
        super.connectedCallback();
        window.addEventListener('click', this._handleOutsideClick);
    }
    disconnectedCallback() {
        super.disconnectedCallback();
        window.removeEventListener('click', this._handleOutsideClick);
    }
    firstUpdated() {
        let dropdownToogle = this.shadowRoot?.querySelector('.dropdown-toggle');
        let gs1DropdownContainer = this.shadowRoot?.querySelector('.dropdown .dropdown-menu');
        const childArray = Array.from(this.children);
        childArray.forEach((item) => {
            if (!item.hasAttribute('slot')) {
                gs1DropdownContainer.appendChild(item);
            }
        });
        dropdownToogle?.classList.remove('charm');
        setTimeout(() => { dropdownToogle?.classList.add('charm'); }, 400);
    }
    toggleVisibility() {
        if (!this.visibility) {
            this.visible = 'show';
            this.arrow = 'up';
        }
        else {
            this.visible = '';
            this.arrow = 'down';
        }
        this.visibility = !this.visibility;
    }
    render() {
        return html `
    ${env.debug ? html `<link rel="stylesheet" href="/css/dropdown.css" />` : html ``}
    <div class="dropdown">
      <button class="btn ${this.type} dropdown-toggle charm ${this.visible}" type="button" id="${this.id}" @click="${this.toggleVisibility}"><span>${this.title}</span><gs1-fa-icon class="dropdown-arrow" family="far" type="fa-angle-${this.arrow}"></gs1-fa-icon></button>
      <ul class="dropdown-menu ${this.visible}" aria-labelledby="${this.id}" @click="${this.toggleVisibility}">
      </ul>
    </div>
    `;
    }
};
__decorate([
    property()
], Dropdown.prototype, "type", void 0);
__decorate([
    property()
], Dropdown.prototype, "id", void 0);
__decorate([
    property()
], Dropdown.prototype, "title", void 0);
__decorate([
    property()
], Dropdown.prototype, "visibility", void 0);
__decorate([
    property({ reflect: true })
], Dropdown.prototype, "visible", void 0);
__decorate([
    property({ reflect: true })
], Dropdown.prototype, "arrow", void 0);
__decorate([
    eventOptions({ capture: false, passive: false })
], Dropdown.prototype, "toggleVisibility", null);
Dropdown = __decorate([
    customElement('gs1-dropdown')
], Dropdown);
export { Dropdown };
//# sourceMappingURL=dropdown.js.map